import { render, staticRenderFns } from "./DataListActivities.vue?vue&type=template&id=39e42259&"
import script from "./DataListActivities.vue?vue&type=script&lang=js&"
export * from "./DataListActivities.vue?vue&type=script&lang=js&"
import style0 from "./DataListActivities.vue?vue&type=style&index=0&id=39e42259&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports